module.exports = __webpack_public_path__ + "img/public/SiteIcons/transportation.svg?bd3a161c";